import React from 'react';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-black to-gray-900 text-white py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-white mb-4">תנאי שימוש</h1>
          <p className="text-gray-300 text-lg">תנאי השימוש של J CLASS MOTORS</p>
        </div>

        <div className="bg-black/50 backdrop-blur-sm border border-amber-500/20 rounded-2xl p-8 space-y-8">
          <div className="bg-amber-500/10 border border-amber-500/30 rounded-lg p-4 mb-8">
            <p className="text-amber-300 text-sm">
              <strong>הערה חשובה:</strong> תנאי השימוש הבאים הם טיוטה בלבד ואינם מהווים ייעוץ משפטי. 
              יש להתייעץ עם עורך דין מוסמך לפני השימוש בתנאים אלה.
            </p>
          </div>

          <section>
            <h2 className="text-2xl font-bold text-amber-400 mb-4 border-b border-amber-500/30 pb-2">
              1. כללי
            </h2>
            <div className="text-gray-300 space-y-3">
              <p>
                השימוש באתר זה מהווה הסכמה לתנאי השימוש המפורטים להלן. 
                אם אינך מסכים לתנאים אלה, אנא הימנע משימוש באתר.
              </p>
              <p>
                החברה רשאית לעדכן את תנאי השימוש מעת לעת ללא הודעה מוקדמת.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-amber-400 mb-4 border-b border-amber-500/30 pb-2">
              2. שירותי החברה
            </h2>
            <div className="text-gray-300 space-y-3">
              <p>J CLASS MOTORS מתמחה בשירותים הבאים:</p>
              <ul className="list-disc list-inside space-y-2 mr-4">
                <li>מכירת רכבי יוקרה וספורט</li>
                <li>קבלת רכבים במסחר (טרייד אין)</li>
                <li>שירותי יבוא רכבים</li>
                <li>שירותי תחזוקה ואחזקה</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-amber-400 mb-4 border-b border-amber-500/30 pb-2">
              3. מחירים ותשלומים
            </h2>
            <div className="text-gray-300 space-y-3">
              <p>
                כל המחירים המוצגים באתר הם במטבע ישראלי (₪) וכוללים מע"ם אלא אם צוין אחרת.
              </p>
              <p>
                החברה רשאית לשנות מחירים ללא הודעה מוקדמת. 
                המחיר הסופי יהיה זה שיוסכם בעת החתימה על ההסכם.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-amber-400 mb-4 border-b border-amber-500/30 pb-2">
              4. אחריות ותחזוקה
            </h2>
            <div className="text-gray-300 space-y-3">
              <p>
                החברה מעניקה אחריות על הרכבים בהתאם לחוק ולתנאי היצרן.
              </p>
              <p>
                פרטי האחריות יינתנו בעת הרכישה ויכללו תקופת האחריות והכסויים הנוספים.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-amber-400 mb-4 border-b border-amber-500/30 pb-2">
              5. מגבלות אחריות
            </h2>
            <div className="text-gray-300 space-y-3">
              <p>
                החברה לא תהיה אחראית לנזקים עקיפים, תוצאתיים או מיוחדים.
              </p>
              <p>
                אחריות החברה מוגבלת לשווי העסקה בלבד.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-amber-400 mb-4 border-b border-amber-500/30 pb-2">
              6. צור קשר
            </h2>
            <div className="text-gray-300 space-y-3">
              <p>לשאלות בנוגע לתנאי השימוש ניתן לפנות אלינו:</p>
              <ul className="list-disc list-inside space-y-2 mr-4">
                <li>טלפון: 058-7019669</li>
                <li>דוא"ל: info@jclassmotors.co.il</li>
                <li>כתובת: תל אביב, ישראל</li>
              </ul>
            </div>
          </section>

          <div className="border-t border-amber-500/30 pt-6 mt-8">
            <p className="text-gray-400 text-sm text-center">
              עדכון אחרון: {new Date().toLocaleDateString('he-IL')} | 
              J CLASS MOTORS - כל הזכויות שמורות
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;